// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_ProcessDiscountsInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/process_deduction_discounts and POST /payroll/process_advance_discounts
 *
 * Validates input for processing discounts for a payroll period.
 * Shared contract for both deduction and advance discount processing endpoints.
 */
import type { PayrollDiscountNestedInput } from './PayrollDiscountNestedInput'
import { registerContract } from './validate'

export interface Payroll_ProcessDiscountsInput {
period_id: number
discounts: PayrollDiscountNestedInput[]
}

registerContract('Payroll_ProcessDiscountsInput', {
  period_id: { type: 'number',  required: true },
  discounts: {
    type: 'array',
    required: true,
    items: {
      amount:       { type: 'number',  required: true },
      deduction_id: { type: 'number',  required: false },
      advance_id:   { type: 'number',  required: false },
    },
  },
})
